import localKey from './localKey'

const devApiUrl = '';//本地开发环境（空字符串走 devServer proxy 转发到 127.0.0.1:8000）
const buildDevApiUrl = 'http://www.moliaos.com/';//打包开发环境
const buildTestApiUrl = 'http://www.moliaos.com/';//打包测试环境
const buildProApiUrl = '/';//打包正式环境

let useApiUrl;
switch (process.env.NODE_ENV) {
    case 'development':
        useApiUrl = devApiUrl;
        break;
    case 'buildDev':
        useApiUrl = buildDevApiUrl;
        break;
    case 'buildTest':
        useApiUrl = buildTestApiUrl;
        break;
    case 'production':
        useApiUrl = buildProApiUrl;
        break;
}

export default {
    nodeDevEnv: process.env.NODE_ENV === 'development',
    apiUrl: useApiUrl,
    apiPrefix: "",
    timeout: 5000,
    requestRetry: 0,
    requestRetryDelay: 800,
    tokenKey: 'ACCESS_TOKEN',
    permissionsKey: 'PERMISSION_ARRAY',
    ...localKey
}
